import isSelectedVariantOutOfStockVariantSelect from 'modules/variant/redux/selectors/is-selected-variant-out-of-stock'
import getAmountGiftSelect from 'modules/gift/redux/selectors/get-amount'
import { createSelector } from 'reselect'
import isDisabledQuickShopProductButtonSelectorUtil from 'containers/QuickShopProductSidebar/components/Button/selectors/is-disabled/utils'
import isSelectedVariantSampledAndRatedVariantSelect from 'modules/variant/redux/selectors/is-selected-variant-sampled-and-rated'

const isDisabledQuickShopProductButtonSelector = ({
  isGiftCard,
  needsToBeRatedSample,
  shouldShowAovLock,
  notDeliveredYet,
  isFullSizeDiscount
}) => createSelector(
  getAmountGiftSelect,
  isSelectedVariantOutOfStockVariantSelect,
  isSelectedVariantSampledAndRatedVariantSelect,
  (
    amount,
    isSelectedVariantOutOfStock,
    isSelectedVariantSampledAndRated
  ) => isDisabledQuickShopProductButtonSelectorUtil({
    amount,
    isSelectedVariantOutOfStock,
    isSelectedVariantSampledAndRated,
    isGiftCard,
    needsToBeRatedSample,
    shouldShowAovLock,
    notDeliveredYet,
    isFullSizeDiscount
  })
)

export default isDisabledQuickShopProductButtonSelector
